import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Area, Box, Modal } from '@ublend-npm/aulaui-core';
import { AulaDispatch, AulaState } from '@core/types/state';
import changeConversationOpen from '@core/conversations/operationsResponsive/changeConversationOpen.action';
import CreateConversation from './CreateConversation';

interface CreateConversationModalProps {
  queryParams?: Record<string, string>;
}

const CreateConversationModal = ({}: CreateConversationModalProps) => {
  const dispatch: AulaDispatch = useDispatch();
  const open = useSelector(
    (state: AulaState) => state.inboxv2.createConversationOpen
  );
  const handleCreateConversationClose = () => {
    dispatch(changeConversationOpen(false));
  };

  return (
    <Modal open={open} onClose={handleCreateConversationClose}>
      <Box width={{ xs: '341px', sm: '407px', md: '562px', lg: '760px' }}>
        <Area rounded>
          <CreateConversation onClose={handleCreateConversationClose} />
        </Area>
      </Box>
    </Modal>
  );
};

export default CreateConversationModal;
